import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Beneficiary } from '../interfaces/beneficiary.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BeneficiaryService {

  private url = environment.url + '/beneficiary';

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    return new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Autorizzazione', localStorage.getItem('token') || '');
  }

  count(sociedadRfc: string) {
    return this.http.get(`${this.url}/count?sociedad=${sociedadRfc}`, { headers: this.getHeaders() })
      .pipe(map(data => data));
  }

  getAllBySociedad(sociedadRfc: string, paginaActual: number, registrosPorPagina: number) {
    return this.http.get(
      `${this.url}/all?pagina=${paginaActual}&registros=${registrosPorPagina}&sociedad=${sociedadRfc}`,
      { headers: this.getHeaders() }
    ).pipe(map(data => data));
  }

  getAllByShareholder(shareholderId: number, paginaActual: number, registrosPorPagina: number) {
    return this.http.get(
      `${this.url}/all/shareholder?pagina=${paginaActual}&registros=${registrosPorPagina}&shareholder=${shareholderId}`,
      { headers: this.getHeaders() }
    ).pipe(map(data => data));
  }

  getById(id: number) {
    return this.http.get(`${this.url}/find/${id}`, { headers: this.getHeaders() })
      .pipe(map(data => data));
  }

  add(beneficiary: Beneficiary, sociedadRfc: string, shareholderUsuarioRfc: string) {
    console.log('Beneficiary:');
    console.log(beneficiary);
    const body = JSON.stringify(beneficiary);
    console.log('Body:');
    console.log(body);
    return this.http.post(
      `${this.url}/add?sociedad=${sociedadRfc}&shareholder=${shareholderUsuarioRfc}`,
      body,
      { headers: this.getHeaders() ,
        reportProgress: true,
        responseType: 'json'}
    ).pipe(map(data => data));
  }

  update(beneficiary: Beneficiary) {
    const body = JSON.stringify(beneficiary);
    return this.http.put(`${this.url}/update`, body, { headers: this.getHeaders() })
      .pipe(map(data => data));
  }

  delete(id: number, sociedadRfc: string) {
    return this.http.delete(
      `${this.url}/delete?beneficiary=${id}&sociedad=${sociedadRfc}`,
      { headers: this.getHeaders() }
    ).pipe(map(data => data));
  }

  getIdentityDocumentUrl(identityId: number): string {
    const token = localStorage.getItem('token') || '';
    return `${environment.url}/beneficiary/identity/${identityId}/document`;
  }

  getIdentityDocument(identityId: number) {
    return this.http.get(
      `${this.url}/identity/${identityId}/document`,
      { headers: this.getHeaders(), responseType: 'blob', observe: 'response' }
    );
  }
}
